import i18n from 'constants/translation/i18n';

const riskAndControlAreas = (t?: any) => {
  const entries = [
    {
      area: 'allocation',
      title: t ? t('ALLOCATION_MAIN') : i18n.t('ALLOCATION_MAIN'),
      href: '/risk-controls/allocation'
    },
    {
      area: 'inventories',
      title: t ? t('INVENTORIES') : i18n.t('INVENTORIES'),
      href: '/risk-controls/inventories'
    },
    {
      area: 'dnd',
      title: t
        ? t('BUSINESS_PROCESS_MAPPING')
        : i18n.t('BUSINESS_PROCESS_MAPPING'),
      href: '/risk-controls/dnd'
    },
    {
      area: 'Testings',
      title: t ? t('CONTROL_TESTING') : i18n.t('CONTROL_TESTING'),
      href: '/risk-controls/testings'
    },
    {
      area: 'reportings',
      title: t ? t('REPORTS') : i18n.t('REPORTS'),
      href: '/risk-controls/reportings'
    },
    {
      area: 'dependencies',
      title: t ? t('DEPENDENCY_TREE') : i18n.t('DEPENDENCY_TREE'),
      href: '/dependency_bpr'
    }
  ];
  return entries;
};

export default riskAndControlAreas;
